export const EXPERIMENTS_INFO = [
  
  {
    url: 'https://res.cloudinary.com/workoutcloud/image/upload/v1754290759/02_HeadOnSmash_lwgamy.png',
    width: 8,
    text: 'This was an impact frame rendered with a toon shader I made in Cinema 4D. It was a lot of fun to really dig into pulling references from some of my favorite artists and animated projects in order to key in the look on this piece, and I hope to animate this project soon.',
  },
  {
    url: '',
    width: 4,
    text: 'This was an impact frame rendered with a toon shader I made in Cinema 4D. It was a lot of fun to really dig into pulling references from some of my favorite artists and animated projects in order to key in the look on this piece, and I hope to animate this project soon.',
  },
  {
    url: '',
    width: 4,
    text: 'This was an impact frame rendered with a toon shader I made in Cinema 4D. It was a lot of fun to really dig into pulling references from some of my favorite artists and animated projects in order to key in the look on this piece, and I hope to animate this project soon.',
  },
  {
    url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157371/03_ProfileSmash_xrfuoh.png',
    width: 8,
    text: "Both of these stills were also touched up in Photoshop, especially in designing the background text.",
  },

  {
    url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1755301924/specRaspberry_ofe7sn.gif',
    width: 6, // accepts values from 1 to 12
    text: 'I made this when I was playing around with a condensation rig and I ended up learning a lot about food rendering and how important subsurface lighting is to making things look real/delicious.',
  },
  
  {
    url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1755302237/RaspberryStill_p5zxzl.png',
    width: 6,
    text: 'No more lighting on this one >:( This was a happy accident when I got frustrated I couldn\'t get the shader right and ended up isolating the highlights, which I think turned out pretty cool!',
  },
  {
    url: '',
    width: 2,
    text: 'This was an impact frame rendered with a toon shader I made in Cinema 4D. It was a lot of fun to really dig into pulling references from some of my favorite artists and animated projects in order to key in the look on this piece, and I hope to animate this project soon.',
  },
  {
    url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1755302531/PlanetProject_3_ncdmvg.gif',
    width: 7,
    text: 'Surprisingly this project was done entirely in After Effects with the Orb plugin. I really wanted to capture a sense of atmosphere and viscerally intense lighting with this one. If you want to see the full version with music check out my Vimeo!',
  },
  {
    url: '',
    width: 2,
    text: 'This was an impact frame rendered with a toon shader I made in Cinema 4D. It was a lot of fun to really dig into pulling references from some of my favorite artists and animated projects in order to key in the look on this piece, and I hope to animate this project soon.',
  },
  {
    url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157524/Exploration_1_an8uh2.png',
    width: 5,
    text: 'Shout out Orb plugin',
  },
  {
    url: '',
    width: 2,
    text: '',
  },
  {
    url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157528/still7_gupbme.png',
    width: 5,
    text: '',
  },
  
];
